import React from 'react';
import { Button } from 'antd';

const VideoModal = ({ isVisible, onClose, video, isImage = false }) => {
  if (!isVisible || !video) return null;

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="video-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="video-modal-header">
          <span className="video-modal-title">{video.name}</span>
          <span className="video-modal-close" onClick={onClose}>&times;</span>
        </div>

        <div className="video-modal-body">
          {isImage ? (
            <img 
              src={video.file_url} 
              alt={video.name}
              style={{ width: '100%', maxHeight: '70vh', objectFit: 'contain' }}
            />
          ) : (
            <video 
              controls 
              autoPlay 
              className="video-player"
              src={video.file_url}
            >
              Your browser does not support the video tag.
            </video>
          )}
        </div>

        <div className="video-modal-footer">
          <Button onClick={onClose} className="custom-btn-cancel">
            Zatvori
          </Button>
        </div>
      </div>

      <style>{`
        .custom-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(4px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .video-modal-container {
          background-color: #1e293b;
          width: 400px;
          max-width: 90vw;
          border-radius: 8px;
          border: 1px solid #334155;
          box-shadow: 0 0 25px 5px rgba(34, 211, 238, 0.4);
          overflow: hidden;
          animation: modalAppear 0.3s ease-out;
        }

        .video-modal-header {
          padding: 16px 24px;
          border-bottom: 1px solid #334155;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .video-modal-title {
          color: white;
          font-size: 16px;
          font-weight: 600;
        }

        .video-modal-close {
          color: #94a3b8;
          font-size: 24px;
          cursor: pointer;
          line-height: 1;
        }

        .video-modal-body {
          padding: 24px;
          background: #0f172a;
        }

        .video-player {
          width: 100%;
          max-height: 70vh;
          border-radius: 4px;
        }

        .video-modal-footer {
          padding: 16px 24px;
          border-top: 1px solid #334155;
          display: flex;
          justify-content: flex-end;
        }

        .custom-btn-cancel {
          background: #334155 !important;
          color: white !important;
          border: none !important;
        }

        @keyframes modalAppear {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default VideoModal;